import { appUrl } from 'utils/wrappers';
import PageableBase from 'app/collections/pageable_base';
import Tracker from 'app/models/tracker';

export default PageableBase.extend({
  model: Tracker,
  key: 'trackers',
  url: appUrl('trackers'),

  initialize(models, { apiMode, dateRange, statusSelection }) {
    this.apiMode = apiMode;
    this.dateRange = dateRange;
    this.statusSelection = statusSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.apiMode, 'change:mode', this.resetToFirstPage);
    this.listenTo(this.statusSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      mode: this.apiMode.get('mode'),
      start_datetime: this.dateRange.getStartDatetimeForParamIso(),
      end_datetime: this.dateRange.getDayAfterEndDatetimeForParamIso(),
      ...this.statusSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/trackers.js